import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentBonusCampaigns,
  getPassedBonusCampaigns,
  handleError,
} from '@homeplay/api';
import {
  selectBonusCampaignsVersion,
  selectUnitToken,
  selectUser,
  setCurrentBonusCampaignsCount,
  setUnitError,
} from '@homeplay/app';
import { Page } from '@homeplay/components';
import BonusCampaignCard from './BonusCampaignCard';
import classes from './BonusCampaigns.module.scss';

const BonusCampaignsList = () => {
  const dispatch = useDispatch();
  const unitToken = useSelector(selectUnitToken);
  const user = useSelector(selectUser);
  const version = useSelector(selectBonusCampaignsVersion);
  const [currentBonuses, setCurrentBonuses] = useState(null);
  const [passedBonuses, setPassedBonuses] = useState([]);

  useEffect(() => {
    if (!unitToken) return;

    let isActive = true;
    Promise.all([
      getCurrentBonusCampaigns(unitToken),
      user ? getPassedBonusCampaigns(unitToken) : [],
    ])
      .then(([current, passed]) => {
        if (isActive) {
          setCurrentBonuses(current);
          setPassedBonuses(passed);
          dispatch(setCurrentBonusCampaignsCount(current.length));
        }
      })
      .catch((error) => {
        if (isActive) {
          setCurrentBonuses([]);
          dispatch(setUnitError({ error: handleError(error) }));
        }
      });

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitToken, user, version]);

  const renderCurrentBonuses = () => {
    if (!currentBonuses) {
      return Array.from({ length: 2 }).map((_, index) => (
        <div key={index} className={classes.CardPlaceholder} />
      ));
    }

    if (!currentBonuses.length) {
      return (
        <p className={classes.Empty}>
          There are no bonuses available right now. Check back soon!
        </p>
      );
    }

    return currentBonuses.map((bonusCampaign) => (
      <BonusCampaignCard key={bonusCampaign.id} bonusCampaign={bonusCampaign} />
    ));
  };

  return (
    <Page headerContent={'Promotions'} customClass={classes.BonusCampaigns}>
      <div className="container">
        <h2 className={classes.SectionTitle + ' color-primary'}>My bonuses</h2>
        <div className={classes.Cards}>{renderCurrentBonuses()}</div>

        {passedBonuses.length > 0 && (
          <>
            <h2 className={classes.SectionTitle + ' color-primary'}>
              Past bonuses
            </h2>
            <div className={classes.Cards}>
              {passedBonuses.map((bonusCampaign) => (
                <BonusCampaignCard
                  key={bonusCampaign.id}
                  bonusCampaign={bonusCampaign}
                  isPassed
                />
              ))}
            </div>
          </>
        )}
      </div>
    </Page>
  );
};

export default BonusCampaignsList;
